<template>
  <v-dialog v-model="show" :max-width="maxWidth" :content-class="contentClass" :attach="attach" :scrollable="scrollable" persistent>
    <v-card class="pa-4">
      <v-row>
        <v-col class="d-flex justify-end" cols="12">
          <v-btn small icon text @click="close" class="mr-5 mt-5">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-card-title class="d-flex justify-center">
        <p :class="$vuetify.breakpoint.smAndUp ? 'text-h4 bluePrimary--text' : 'text-h4 bluePrimary--text'" style="word-break: keep-all; text-align: center; font-weight: bold">
          {{ title }}
        </p>
      </v-card-title>
      <v-card-text class="mt-5 px-0 px-md-6">
        <slot></slot>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn
          class="text-none"
          width="110"
          color="bluePrimary"
          outlined
          rounded
          @click="close"
          >{{ textBtnClose }}</v-btn
        >
        <v-btn
          color="bluePrimary white--text text-none"
          rounded
          @click="confirm"
          width="110"
          v-if="!viewMode"
          >{{ textBtn }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogComponent",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    textBtn: {
      type: String,
      default: "Confirmar",
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    maxWidth:{
      type: Number | String,
      default: 900
    },
    textBtnClose: {
      type: String,
      default: "Cancelar",
    },
    contentClass: {
      type: String,
      default: '',
    },
    attach: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped>
:deep(.v-dialog) {
  box-shadow: none;
}

.v-card {
  border-radius: 50px;
}

@media screen and (min-width: 280px) {
  .custom_title {
    font-size: 16px;
  }
}
</style>
